var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',_vm._b({ref:"modal",attrs:{"busy":true,"hide-footer":""}},'b-modal',_vm.$attrs,false),[_c('div',{staticClass:"r-clean-modal flex justify-center flex-column"},[_c('r-video',{attrs:{"src":_vm.video.url,"poster":_vm.video.thumbnail}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }